module.exports = __webpack_public_path__ + "img/customer_shipping_paid.5b799076.svg";